import React, { useEffect, useRef } from "react";
import Image from "next/image";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import GlobalForm from "@/components/forms/GlobalForm";
import {
  FinanceAndAccountingSubcategory,
  FormHeading,
  SuccessMessageType,
  VerticalCategory,
} from "@/interface/types";

const UspVisitBannerMobile = () => {
  const autoplayRef = useRef(
    Autoplay({
      delay: 1500,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
    }),
  );

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      dragFree: true,
      containScroll: "trimSnaps",
    },
    [autoplayRef.current],
  );

  useEffect(() => {
    if (emblaApi && autoplayRef.current) {
      autoplayRef.current.play();
    }
  }, [emblaApi]);

  const companyLogos = [
    { src: "/cpa/usp/us_logo1.png", alt: "MBE", width: 75, height: 45 },
    { src: "/cpa/usp/us_logo2.png", alt: "MBE", width: 105, height: 40 },
    { src: "/cpa/usp/us_logo3.png", alt: "MBE", width: 45, height: 58 },
    { src: "/cpa/usp/us_logo4.png", alt: "MBE", width: 122, height: 35 },
    { src: "/cpa/usp/us_logo5.png", alt: "MBE", width: 80, height: 55 },
    { src: "/cpa/usp/us_logo6.png", alt: "MBE", width: 105, height: 39 },
    { src: "/cpa/usp/us_logo7.png", alt: "MBE", width: 89, height: 56 },
    { src: "/cpa/usp/us_logo8.png", alt: "MBE", width: 90, height: 20 },
  ];

  const companyLogosDuplicated = [...companyLogos, ...companyLogos];

  return (
    <>
      <div className="w-full bg-white">
        <div className="mx-auto w-full 2xl:h-[700px] md:h-[95vh] h-[auto] xl:px-0 md:px-6 lg:!px-6  px-0  md:bg-bottom bg-center square_grid_bg bg-inherit bg-repeat bg-auto bg-[length:100% 100%] md:pb-0 pb-[0px]">
          <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-20 relative">
            <div className="flex justify-between flex-wrap 2xl:items-center items-center 2xl:h-[650px] md:h-[65vh] h-[auto]">
              <div className="md:pt-5 pt-[45px] pb-[0px] w-full md:pb-16 relative 2xl:top-[50px] md:top-[120px] mt-0 md:ml-[70px]">
                <Image
                  src="/usp/usp-gif.png"
                  alt="Work in the US"
                  className="mx-auto mt-0 w-[80%]"
                  width={600}
                  height={225}
                />

                <div className="text-center">
                  <p className="font-medium text-[16px] leading-[116%] tracking-[-0.64px] text-[#202852]">
                    Miles has cracked the puzzle
                    <br />
                    for Indian Accountants to
                  </p>
                  <div className="flex flex-col gap-2 justify-center pt-[1px]">
                    <p className="text-[#0C1F33] text-center text-[40px] not-italic font-bold leading-normal tracking-[-1.6px]">
                      Work in the US
                    </p>
                    <hr className="border-0 h-px bg-[#C6C6C6] w-[114px] mx-auto mt-[-12px]" />

                    <div className="w-[340px] mx-auto relative">
                      <Image
                        src="/accounting/vec.svg"
                        alt="CPA Recruiting firms"
                        className="absolute left-[38px] bottom-2"
                        width={28}
                        height={46}
                      />

                      <p className="text-[#0C1F33] font-semibold text-[20px] leading-[28px] text-center mt-[-3px]">
                        Starting Salary
                      </p>
                      <Image
                        src="/accounting/vec2.svg"
                        alt="CPA Recruiting firms"
                        className="absolute right-[41px] bottom-0 "
                        width={23}
                        height={44}
                      />
                    </div>

                    <p className="">
                      <span className="bg-[#FFBA08] text-[20px] leading-[23px] font-semibold text-[#000] text-center px-[20px] py-[5px]">
                        $60,000+ (₹50 lakhs+)
                      </span>
                    </p>
                  </div>

                  <div
                    className="p-4 border border-white rounded-2xl m-4"
                    style={{
                      background:
                        "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
                      boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
                      backdropFilter: "blur(28px)",
                    }}
                  >
                    <Image
                      src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
                      alt="star group"
                      width={34}
                      height={38}
                      className="absolute top-1 left-0"
                    />
                    <GlobalForm
                      course="USP"
                      courseId={3}
                      formHeading={
                        FormHeading.WORLD_FAVORITE_CMA_CPA_INSTRUCTOR
                      }
                      formType="page"
                      isAStepperForm={true}
                      pageType="business page"
                      subCategory={FinanceAndAccountingSubcategory.USP}
                      submitButtonName="Download Brochure"
                      successMessage={SuccessMessageType.ACCOUNTING}
                      verticalName={VerticalCategory.FINANCE_AND_ACCOUNTING}
                      showSVG={false}
                      darkBackground={false}
                    />
                  </div>

                  <div className="mt-5">
                    <div className="banner_card ">
                      <div className="flex items-center justify-between text-[#202852] border-[#3174d6]">
                        <div>
                          <p className="text-center text-[20px] not-italic font-semibold leading-[normal] tracking-[-1.2px] pb-[4px]">
                            70,000+
                          </p>
                          <p className="text-center text-[10px] text-[#202852] not-italic font-medium leading-[normal] tracking-[-0.48px] capitalize">
                            Global Alumni
                          </p>
                        </div>
                        <div className="grey_divider"></div>
                        <div>
                          <p className="text-center text-[20px] not-italic text-[#202852] font-semibold leading-[normal] tracking-[-1.2px] pb-[4px]">
                            600+
                          </p>
                          <p className="text-center text-[10px] not-italic text-[#202852] font-medium leading-[normal] tracking-[-0.48px] capitalize">
                            Corporates
                          </p>
                        </div>
                        <div className="grey_divider"></div>
                        <div>
                          <p className="text-center text-[20px] not-italic text-[#202852] font-semibold leading-[normal] tracking-[-1.2px] pb-[4px]">
                            100+
                          </p>
                          <p className="text-center text-[10px] not-italic text-[#202852] font-medium leading-[normal] tracking-[-0.48px] capitalize">
                            Universities
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="w-full mt-[35px]">
                    <h2 className=" text-[13px] text-[#848484] flex justify-center items-center font-medium">
                      <Image
                        src="/cpa/StarFour.png"
                        alt="CPA Recruiting firms"
                        className=""
                        width={12}
                        height={12}
                      />
                      <span className="leading-[1] mx-3 text-12px font-medium">
                        {" "}
                        OUR ALUMNI WORK AT
                      </span>
                      <Image
                        src="/cpa/StarFour.png"
                        alt="CPA Recruiting firms"
                        className=""
                        width={12}
                        height={12}
                      />
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg_desktop">
              <Image
                src="/images/accounting/usp/mobile-banner.png"
                alt="Work in the US"
                className="absolute top-0 bottom-0 right-0 w-full z-[-9] md:h-full md:rounded-b-[24px]"
                width={920}
                height={680}
              />
            </div>
          </div>

          <div className="pb-[20px] mt-5">
            <div className="embla overflow-hidden w-full pb-4" ref={emblaRef}>
              <div
                className="embla__container flex"
                style={{
                  backfaceVisibility: "hidden",
                  transform: "translate3d(0, 0, 0)",
                }}
              >
                {companyLogosDuplicated.map((logo, index) => (
                  <div
                    key={`company-${index}`}
                    className="embla__slide flex-[0_0_auto] flex-shrink-0 flex items-center justify-center"
                    style={{
                      minWidth: "80px",
                      marginRight: "25px",
                    }}
                  >
                    <Image
                      src={logo.src}
                      alt={logo.alt}
                      className="mx-auto"
                      width={logo.width}
                      height={logo.height}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="md_desktop">
            <Image
              src="/images/accounting/usp/mobile-banner.png"
              alt="Work in the US"
              className="absolute top-0 bottom-0 left-0 right-0 2xl:h-[750px] xl:w-full lg:w-full md:block hidden md:h-[95vh] md:rounded-b-[24px]"
              width={920}
              height={680}
            />
          </div>
          <Image
            src="/images/accounting/usp/mobile-banner-usp.png"
            alt="accounting jobs in usa"
            className="absolute top-0 bottom-0 right-0 left-0 md:hidden block w-full "
            width={360}
            height={84}
          />

          <Image
            src="/images/accounting/usp/mobile-banner-bg.png"
            alt="Work in the US"
            className="absolute left-0 right-0 bottom-[-58px] w-full"
            width={360}
            height={225}
          />
        </div>
      </div>
    </>
  );
};

export default UspVisitBannerMobile;
